<template>
    <div id="flow-list" class="flow-list ht-scroll-vertical">
        <form action="javascript:void(0)">
            <van-search disabled background="#f5f5f5" placeholder="点击搜索" :clearable="false" @click="onSearchClick"/>
        </form>

        <div v-if="!!innerSearchJson" class="ht-text-assist"
             @click="onResetSearchClick"
             style="margin-bottom: 10px; text-align: center;">
            点击显示全部
        </div>

        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                @load="onLoad"
                style="padding: 0 15px"
                v-if="!emptyShow"
        >
            <FlowListItem v-for="(item,index) in list" :key="index" :type="type" :item="item" @deleteHandler="deleteHandler"/>
        </van-list>
        <div class="empty-container" v-else>
          <Error type="empty"/>
        </div>
    </div>
</template>

<script>
import {List, Search, Icon} from 'vant'
import FlowListItem from "@/components/Flow/FlowListItem"
import {queryList} from '@/api/flow'
import {getPlatformInstance} from "@/platforms"

export default {
    name: 'FlowList',
    components: {
        [List.name]: List,
        [Search.name]: Search,
        [Icon.name]: Icon,
        FlowListItem,
    },
    props: ['type', 'flowKey', 'searchJson', 'searchFieldJson'],
    data() {
        return {
            list: [],
            loading: false,
            finished: false,
            error: false,
            pageIndex: 0,
            innerSearchJson: '',
            innerSearchFieldJson: '',
            emptyShow: false //空空如也是否显示
        }
    },
    computed: {},
    created() {
        const TITLE = {
            send: '已发',
            todo: '待办事项',
            done: '已办事项',
            copy: '抄送给我',
            reply: '最新回复',
            draft: '草稿箱',
            ongoing: '进行中',
            end: '已结束',
        }
        getPlatformInstance().then(platform => platform.setTitle(TITLE[this.type]))
        this.innerSearchJson = this.searchJson
        this.innerSearchFieldJson = this.searchFieldJson
    },
    methods: {
        onLoad() {
            this.loading = true;
            queryList(this.type, this.flowKey, this.pageIndex, this.innerSearchJson, this.innerSearchFieldJson)
                    .then(resp => {
                        if(resp.data){
                          this.list = this.list.concat(resp.data)

                          if (this.list.length >= resp.total) this.finished = true
                          if (!resp.total){
                            this.emptyShow = true;
                          } else {
                            this.emptyShow = false;
                          }
                          this.pageIndex++
                          this.loading = false
                        }else{
                          this.loading = false
                          if (this.list && this.list.length == 0) {
                            this.emptyShow = true;
                          }
                        }
                    })
                    .catch(error => {
                        this.loading = false
                        this.error = true
                      // this.$router.push('/empty/error')
                    })
                    .finally(() => {
                      this.loading = false
                    })
        },
        deleteHandler(id) {
            this.list = this.list.filter(item => item.id != id)
        },
        onSearchClick() {
          let flowId = '';
          if(this.list.length>0 && this.list[0].wfInfoId) {
            flowId = this.list[0].wfInfoId;
            this.$router.push({name: 'FLOW_LIST_SEARCH', params: {flowId: flowId,type: this.type, flowKey: this.flowKey, innerSearchJson: this.innerSearchJson, searchFieldJson: this.innerSearchFieldJson}})
          } else {
            queryList(this.type, this.flowKey, 0).then(res => {
              if(res.data && res.data.length>0){
                flowId = res.data[0].wfInfoId
                this.$router.push({name: 'FLOW_LIST_SEARCH', params: {flowId: flowId,type: this.type, flowKey: this.flowKey, innerSearchJson: this.innerSearchJson, searchFieldJson: this.innerSearchFieldJson}})
              } else {
                flowId = "";
                this.$router.push({name: 'FLOW_LIST_SEARCH', params: {flowId: flowId,type: this.type, flowKey: this.flowKey, innerSearchJson: this.innerSearchJson, searchFieldJson: this.innerSearchFieldJson}})
              }
            })
          }
        },
        getFlowId() {
          let flowId = '';
          queryList(this.type, this.flowKey, 0).then(res => {
            if(res.data && res.data.length>0){
              flowId = res.data[0].wfInfoId
            }
          })
        },
        onResetSearchClick(){
            this.$router.push({path: `/flow/list/${this.type}/${this.flowKey}`})
            this.loading = false
            this.finished = false
            this.error = false
            this.pageIndex = 0
            this.innerSearchJson = ''
            this.innerSearchFieldJson = ''
            this.list = []
            this.onLoad()
        }
    }
}
</script>

<style scoped lang="scss">
.flow-list {
    height: 100vh;

    .van-search {
        padding: 10px 15px;
    }

    .van-search__content {
        background-color: #ffffff;
    }
}
</style>
